var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.960693H513V342.967H0V0.960693Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.151 43.674L229.117 59.8155L246.922 62.4005L234.037 74.965L237.082 92.6996L221.151 84.3232L205.22 92.6996L208.256 74.965L195.371 62.4005L213.186 59.8155L221.151 43.674ZM291.849 43.6139L299.815 59.7453L317.63 62.3404L304.744 74.8949L307.78 92.6395L291.849 84.2631L275.918 92.6395L278.964 74.8949L266.079 62.3404L283.884 59.7453L291.849 43.6139ZM354.05 54.9961L362.016 71.1375L379.821 73.7226L366.936 86.2871L369.982 104.022L354.05 95.6553L338.119 104.022L341.165 86.2871L328.27 73.7226L346.085 71.1375L354.05 54.9961ZM417.184 73.3318L425.149 89.4733L442.954 92.0683L430.069 104.623L433.115 122.367L417.184 113.991L401.253 122.367L404.288 104.623L391.403 92.0683L409.218 89.4733L417.184 73.3318ZM158.95 54.9961L166.916 71.1375L184.73 73.7226L171.835 86.2871L174.881 104.022L158.95 95.6553L143.019 104.022L146.065 86.2871L133.18 73.7226L150.985 71.1375L158.95 54.9961ZM95.8171 73.3318L103.783 89.4733L121.597 92.0683L108.712 104.623L111.748 122.367L95.8171 113.991L79.8861 122.367L82.932 104.623L70.0469 92.0683L87.8516 89.4733L95.8171 73.3318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.955 260.797L190.681 247.161L163.408 192.624H190.681L217.955 165.351L231.591 138.078L258.864 124.441L272.501 138.078L299.774 151.715V165.351L313.411 178.988L354.32 206.261L340.664 247.171L299.754 288.08L286.117 260.807L245.208 288.08V315.354L231.571 301.717L217.955 260.797Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.997,
    fill: "white",
    transform: "translate(0 0.960693)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXk);
export default __webpack_public_path__ + "static/media/XK.70fc0f47c5ca3964d8469f18bdaf2a22.svg";
export { ForwardRef as ReactComponent };